import React from 'react';

// @material-ui
import { Grid as MuiGrid } from '@material-ui/core';

// core
import { ProfileInfoForm } from '_core/views/ProfileInfoForm';
import { ProfileVerification } from '_core/views/ProfileVerification';
import { ProfileSecurityForm } from '_core/views/ProfileSecurityForm';
import { ProfileOrgInfo } from '_core/views/ProfileOrgInfo';
import { ProfileDeliveryInfoForm } from '_core/views/ProfileDeliveryInfoForm';
import { CurrencyRates } from '_core/views/CurrencyRates';
import { ProductList } from '_core/views/ProductList';
import { ServiceList } from '_core/views/ServiceList';
import { Article } from '_core/views/Article';
import { ReferralLink } from '_core/components/ReferralLink';

import { ARTICLE_KEY, PROFILE_TAB_URL, ARTICLE_TIMEOUT } from 'basic/config';
import { BlockedMoneyNotice } from 'basic/views/BlockedMoneyNotice';
import { OwnGoodsList } from 'basic/views/OwnGoodsList';
import { StatsFinance } from 'basic/views/StatsFinance';
import { PopupMessages } from 'basic/views/PopupMessages';

export const Slot = (path, props) => () => (
  <Article
    path={path}
    hasDate={false}
    renderFailure={() => null}
    renderProgress={() => null}
    stateProps={{ timeout: ARTICLE_TIMEOUT }}
    {...props}
  />
);

export const Props = (Component, props) => () => (
  <Component {...props} />
);

export const Grid = (...components) => () => (
  <MuiGrid container>
    {components.map(([Component, gridProps, componentProps], index) => (
      <MuiGrid item key={index} {...gridProps}>
        <Component {...componentProps} />
      </MuiGrid>
    ))}
  </MuiGrid>
);

export const StartPacks = () => (
  <ProductList requestParams={{ shop: 'start' }} renderEmpty={() => null} />
);

export const ServicePacks = () => (
  <ServiceList requestParams={{ shop: 'start' }} renderEmpty={() => null} />
);

export const slots = {
  // separate pages
  dashboard: [
    Slot(ARTICLE_KEY.DASHBOARD_SLOT),
    StatsFinance,
    PopupMessages,
    ReferralLink,
    CurrencyRates,
    OwnGoodsList,
  ],
  catalog: [Slot(ARTICLE_KEY.CATALOG_SLOT)],
  product: [Slot(ARTICLE_KEY.PRODUCT_SLOT)],
  payment: [Slot(ARTICLE_KEY.PAYMENT_SLOT)],

  // `partner` menu group pages
  binary: [Slot(ARTICLE_KEY.BINARY_SLOT)],
  matrix: [Slot(ARTICLE_KEY.MATRIX_SLOT)],
  structure: [Slot(ARTICLE_KEY.STRUCTURE_SLOT)],

  // `finance` menu group pages
  topup: [BlockedMoneyNotice, Slot(ARTICLE_KEY.TOPUP_SLOT)],
  transmit: [BlockedMoneyNotice, Slot(ARTICLE_KEY.TRANSMIT_SLOT)],
  exchange: [BlockedMoneyNotice, Slot(ARTICLE_KEY.EXCHANGE_SLOT)],
  withdraw: [BlockedMoneyNotice, Slot(ARTICLE_KEY.WITHDRAW_SLOT)],

  // `history` menu group pages
  financelog: [BlockedMoneyNotice, Slot(ARTICLE_KEY.FINANCELOG_SLOT)],
  withdrawlog: [BlockedMoneyNotice, Slot(ARTICLE_KEY.WITHDRAWLOG_SLOT)],
  purchaselog: [BlockedMoneyNotice, Slot(ARTICLE_KEY.PURCHASELOG_SLOT)],

  // `support` menu group pages
  faq: [Slot(ARTICLE_KEY.FAQ_SLOT)],
  tickets: [Slot(ARTICLE_KEY.TICKETS_SLOT)],

  profileTabs: [
    {
      icon: 'info',
      label: 'r.informaciya',
      value: PROFILE_TAB_URL.INFO,
      ContentComponent: ProfileInfoForm,
    },
    {
      icon: 'business',
      label: 'r._.company.name',
      value: PROFILE_TAB_URL.COMPANY,
      ContentComponent: ProfileOrgInfo,
    },
    {
      icon: 'check_circle_outline',
      label: 'r.verifikaciya',
      value: PROFILE_TAB_URL.VERIFICATION,
      ContentComponent: ProfileVerification,
    },
    // {
    //   icon: 'assignment_turned_in',
    //   label: 'r.dogovora',
    //   value: PROFILE_TAB_URL.CONTRACT,
    //   ContentComponent: ProfileContractForm,
    // },
    {
      icon: 'security',
      label: 'r.bezopasnost',
      value: PROFILE_TAB_URL.SECURITY,
      ContentComponent: ProfileSecurityForm,
    },
    // {
    //   icon: 'send',
    //   label: 'r.podpiska',
    //   value: PROFILE_TAB_URL.SUBSCRIPTION,
    //   ContentComponent: ProfileSubscriptionForm,
    // },
    {
      icon: 'shop',
      label: 'backoffice.buy.deliv',
      value: PROFILE_TAB_URL.DELIVERY,
      ContentComponent: ProfileDeliveryInfoForm,
    },
  ],
};
